// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".emp-menu[data-v-8bd1f84e]{--bg-opacity:1;background-color:#fafafa;background-color:rgba(250,250,250,var(--bg-opacity))}.emp-menu__items[data-v-8bd1f84e]{width:100%;padding-top:.75rem;padding-bottom:.75rem}.emp-menu__items .b.b-nav[data-v-8bd1f84e]{padding-left:1.5rem;padding-right:1.5rem}.emp-menu__items .b.b-nav[data-v-8bd1f84e],.emp-menu__items .b.b-nav[data-v-8bd1f84e]:after{border-radius:0}", ""]);
// Exports
module.exports = exports;
